import React from "react";
import "./OutStore.css";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";


const imageUrls = [
  {
   img: "/Images/music-store-logos/TikTok_logo.png",
   link: "/distribute-music-on-apple-music"
  },
  { 
    img: "/Images/music-store-logos/TikTok_logo-1.png",
   link: "/get-music-on-tik-tok"
  },
  { 
    img:"/Images/music-store-logos/deezer.png",
    link: "/get-music-on-deezer"
  },
  { 
    img:"/Images/music-store-logos/jio.png",
    link: "/get-music-on-jio-saavn"
  },
  { 
    img:"/Images/music-store-logos/spotify.png",
    link: "/get-verified-on-spotify"
  },
 { 
    img:"/Images/music-store-logos/boomplay.png",
    link: "/get-music-on-boomplay"
  },
  { 
    img:"/Images/music-store-logos/anghami.png",
    link:"/get-music-on-anghami"
  },
    { 
    img:"/Images/music-store-logos/amazon-music.png",
    link:"/get-music-on-amazon-music"
  },
    { 
    img:"/Images/music-store-logos/google-play-music-logo.png",
    link:"/get-music-on-google-play-music"
    },
      { 
    img:  "/Images/music-store-logos/7d_wordmark_colour_RGB-300x94-1.png",
    link:"/get-music-on-7digital"
      },
    { 
    img:"/Images/music-store-logos/awa-1-1.png",
    link:"/get-music-on-awa"
  },
    
  // "https://gallery.vision/wp-content/uploads/2022/12/awa-1-1-150x51.png",
    { 
    img:"/Images/music-store-logos/Beatport-logo-1.png",
    link:"/get-music-on-beatport"
    },
    { 
    img:"/Images/music-store-logos/beatsource-blue-logo-1.png",
    link:"/get-music-on-beatsource"
    },
    { 
    img:"/Images/music-store-logos/tidal-logo-stack-1.png",
    link:"/get-music-on-tidal"
    },
    { 
    img:"/Images/music-store-logos/Facebook-Logo.wine-1.png",
    link:"/get-music-on-facebook"
    },
    { 
    img:"/Images/music-store-logos/logos_youtube.png",
    link:'/get-music-on-youtube'
    },
      { 
    img:"/Images/music-store-logos/1-1-1.png",
    link:'/get-music-on-bleep'
    },
    { 
    img:"/Images/music-store-logos/bmat-horizontal-logo-1.png",
    link:'/get-music-on-bmat'
  },
   { 
    img: "/Images/music-store-logos/Gracenote_A_Nielsen_Company_Logo-1.png",
    link:'/get-music-on-gracenote'
    },
  // "https://gallery.vision/wp-content/uploads/2022/12/Gracenote_A_Nielsen_Company_Logo-1-300x150.png",
    { 
    img:"/Images/music-store-logos/Fizy_logo-1.png",
    link:'/get-music-on-fizy'
    },
    { 
    img:"/Images/music-store-logos/Tencent_Logo-1.png",
    link:'/get-music-on-tencent'
    },
    { 
    img:" /Images/music-store-logos/350-3508352_ups-truck-clip-art-1.png",
    link:'/get-music-on-hungama'
  },
    { 
    img:"/Images/music-store-logos/Vevo_2016_Logo-1.png",
    link:'/get-music-on-vevo'
  },
    { 
    img:"/Images/music-store-logos/SoundCloud_-_Logo-1.png",
    link:'/get-music-on-sound-cloud'
  },
    { 
    img:"/Images/music-store-logos/huawei-ar21-1.png",
    link:'/get-music-on-huawei'
  },
  // "/Images/music-store-logos/huawei-ar21-1-300x150.png",
    { 
    img:"/Images/music-store-logos/Lenovo_logo_2015-1.png",
    link:'/get-music-on-lenovo'
  },
    { 
    img:"/Images/music-store-logos/Gionee_logo-1.png",
    link:'/get-music-on-gionee'
  },
    { 
    img:"/Images/music-store-logos/raaga_logo_new-1.png",
    link:'/get-music-on-raaga'
  },
    { 
    img:"/Images/music-store-logos/Frame-180.png",
    link:'/get-music-on-youtube-music'
  },
    { 
    img:"/Images/music-store-logos/Onkyo_logo-1.png",
    link:'/get-music-on-onkyo'
  },
    { 
    img:"/Images/music-store-logos/KKBOX_logo-1.png",
    link:'/get-music-on-kkbox'
  },
    { 
    img:"/Images/music-store-logos/LINE_MUSIC_logo-1.png",
    link:'/get-music-on-line-music'
  },
    { 
    img:"/Images/music-store-logos/Yandex_logo-1.png",
    link:'/get-music-on-yandex'
  },
    { 
    img:"/Images/music-store-logos/Beat.no_.png",},
    { 
    img:"/Images/music-store-logos/Boucher.png",},
    { 
    img:"/Images/music-store-logos/Ex-Libris.png",},
    { 
    img:"/Images/music-store-logos/grandPad_logo-1.png",},
    { 
    img:"/Images/music-store-logos/Glonal-Radio.png",},
    { 
    img:"/Images/music-store-logos/NEC-Logo.wine-1.png",},
    { 
    img:"/Images/music-store-logos/My-Melo.png",},
    { 
    img:"/Images/music-store-logos/clipart1843917-1.png",},
    { 
    img:"/Images/music-store-logos/Frame-183.png",},
    { 
    img:"/Images/music-store-logos/XMLID_23_.png",},
    { 
    img:"/Images/music-store-logos/Frame-186.png",},
    { 
    img:"/Images/music-store-logos/Naver_Logotype-1.png",},
    { 
    img:"/Images/music-store-logos/Rakuten_Global_Brand_Logo-1.png",},
   { 
    img: "/Images/music-store-logos/Shazam_logo-1-1.png",},
    { 
    img:"/Images/music-store-logos/SoundMachine-Logo-1.png",},
    // { 
    // img:"/Images/music-store-logos/SoundMachine-Logo-1-300x171.png",},
    { 
    img:"/Images/music-store-logos/stacked-black-1.png",},
    { 
    img:"/Images/music-store-logos/Frame-192.png",},
    { 
    img:"/Images/music-store-logos/Movistar_2020_logo-1.png",},
    { 
    img:"/Images/music-store-logos/Nightlife-Music.png",},
  // "/Images/music-store-logos/Nightlife-Music-300x40.png",
    { 
    img:"/Images/music-store-logos/dfccd6fa3d-1.png",},
    { 
    img:"/Images/music-store-logos/service_trackdrip-1.png",},
    { 
    img:"/Images/music-store-logos/logo-standard-for-light-background-1.png",},
    { 
    img:"/Images/music-store-logos/e6e16a0ad6f5a27268734db6022db0a3-1.png",},
    { 
    img:"/Images/music-store-logos/cropped-Hardstylecom_gradient_logo_Tekengebied-1-kopie-3-1920x314-1.png",},
  // "/Images/music-store-logos/cropped-Hardstylecom_gradient_logo_Tekengebied-1-kopie-3-1920x314-1-300x50.png",
    { 
    img:"/Images/music-store-logos/Brasbeat.png",},
    { 
    img:"/Images/music-store-logos/Xite.png",},
    { 
    img:"/Images/music-store-logos/MOra-Qualitas.png",},
    { 
    img:"/Images/music-store-logos/Audible-Magic.png",},
    { 
    img:"/Images/music-store-logos/Bugs.png",},
    { 
    img:"/Images/music-store-logos/Dubeset-Media.png",},
  // "/Images/music-store-logos/Dubeset-Media-300x30.png",
    { 
    img:"/Images/music-store-logos/Kakakoo-Music.png",},
  // "/Images/music-store-logos/Kakakoo-Music-300x31.png",
    { 
    img:"/Images/music-store-logos/Sirius_XM_Radio_Logo-1.png",},
    { 
    img:"/Images/music-store-logos/Intersect.png",},
   { 
    img: "/Images/music-store-logos/Aldi-Life.png",},
     { 
    img:"/Images/music-store-logos/Naver-Music-300x38.png",},
    { 
    img: "/Images/music-store-logos/Hofer-Life.png",},
     { 
    img:"/Images/music-store-logos/Jaypay-Official-Site-removebg-preview-1.png",},
     { 
    img:"/Images/music-store-logos/Sound-Machine.png",},
     { 
    img:"/Images/music-store-logos/Hits-NL.png",},
    { 
    img: "/Images/music-store-logos/juno-logo-1.png",},
     { 
    img:"/Images/music-store-logos/JOOX_font_logo-1.png",},
     { 
    img:"/Images/music-store-logos/Jupiter_Telecommunications_logo-1.png",},
     { 
    img:"/Images/music-store-logos/Jaxsta_Black-1.png",},
     { 
    img:"/Images/music-store-logos/itunes-1.png",},
     { 
    img:"/Images/music-store-logos/633e81778a-removebg-preview-1.png",},
     { 
    img:"/Images/music-store-logos/b09c54b8ae-removebg-preview-1.png",},
     { 
    img:"/Images/music-store-logos/870dd72fd4-removebg-preview-1.png",},
  // "https://gallery.vision/wp-content/uploads/2022/12/870dd72fd4-removebg-preview-1.png",
  // "https://gallery.vision/wp-content/uploads/2022/12/870dd72fd4-removebg-preview-1-300x94.png",
     { 
    img:"/Images/music-store-logos/672508d557webp-removebg-preview-1.png",},
     { 
    img:"/Images/music-store-logos/f6a032b79e0c1e031bfac4adee618e81f0c73724-1.png",},
     { 
    img:"/Images/music-store-logos/b387c5da9awebp-removebg-preview-1.png",},
  // "https://gallery.vision/wp-content/uploads/2022/12/b387c5da9awebp-removebg-preview-1.png",
  // "https://gallery.vision/wp-content/uploads/2022/12/b387c5da9awebp-removebg-preview-1-300x132.png",
     { 
    img:"/Images/music-store-logos/Frame-225.png",},
     { 
    img:"/Images/music-store-logos/VK_Full_Logo_2021-present-1.png",},
     { 
    img:"/Images/music-store-logos/cb844772e3-removebg-preview-1.png",},
     { 
    img:"/Images/music-store-logos/HMV-1.png",},
     { 
    img:"/Images/music-store-logos/kolbi_hor_positive-1.png",},
  // "https://gallery.vision/wp-content/uploads/2022/12/kolbi_hor_positive-1.png",
  // "https://gallery.vision/wp-content/uploads/2022/12/kolbi_hor_positive-1-150x150.png",
     { 
    img:"/Images/music-store-logos/qq-music-1.png",},
     { 
    img:"/Images/music-store-logos/TIM_logo_2016-1.png",},
     { 
    img:"/Images/music-store-logos/Bitel-1.png",},
     { 
    img:"/Images/music-store-logos/Vodafone-Logo.wine-1.png",},
     { 
    img:"/Images/music-store-logos/261px-Digicel_logo-1.png",},
     { 
    img:"/Images/music-store-logos/Virgin_Mobile_logo-1.png",},
     { 
    img:"/Images/music-store-logos/Orange_logo-1.png",},
     { 
    img:"/Images/music-store-logos/odnoklassniki-ok-logo-vector-1.png",},
     { 
    img:"/Images/music-store-logos/MTN_logo-1.png",},
    { 
    img: "/Images/music-store-logos/Zazell.nl_.png",},
     { 
    img:"/Images/music-store-logos/Top40.nl_.png",},
     { 
    img:"/Images/music-store-logos/Net5.nl_.png",},
     { 
    img:"/Images/music-store-logos/SBS6.in_.png",},
     { 
    img:"/Images/music-store-logos/Mocreate.nl_.png",},
     { 
    img:"/Images/music-store-logos/GTL.png",},
     { 
    img:"/Images/music-store-logos/Mega-media.nl_.png",},
  // "https://gallery.vision/wp-content/uploads/2022/12/Mega-media.nl_.png",
  // "https://gallery.vision/wp-content/uploads/2022/12/Mega-media.nl_-300x38.png",
     { 
    img:"/Images/music-store-logos/TVOranhe.nl_.png",},
     { 
    img:"/Images/music-store-logos/Nuuday.png",},
     { 
    img:"/Images/music-store-logos/Touch-Tunes.png",},
     { 
    img:"/Images/music-store-logos/Playnetwork.png",},
  // "https://gallery.vision/wp-content/uploads/2022/12/Playnetwork.png",
  // "https://gallery.vision/wp-content/uploads/2022/12/Playnetwork-300x45.png",
     { 
    img:"/Images/music-store-logos/Wynklogo-Horiz-big.png",},
];



const OutStore = () => {
  const navigate = useNavigate();
  return (
    <div className="our-storee">
      <div className="our-store-bg"></div>
      
      <section className="section-logo">
        <Container>
          <div className="text-align-center">
            <motion.div 
              className="center-title_wrapper"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="tag-component">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
                GLOBAL NETWORK
              </div>
              
              <h2 className="outstore-heading">
                <span className="text-gradient-orange">FTunes &ndash;</span><br />
                Music Distribution <span className="text-gradient-pink">Partners</span>
              </h2>
              
              <p className="our-store-paraa">
                Get your music out to the best, biggest, and most popular platforms across the world.
              </p>
              
              <button
                className="btn-distribute-music"
                onClick={() => navigate("/music-distribution-pricing")}
              >
                DISTRIBUTE YOUR MUSIC
                <div className="btn-icon-circle">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              </button>
            </motion.div>
          </div>

          <div className="logo-large_content-wrapper">
            <div className="logo-large-list">
              {imageUrls.map((item, index) => (
                <motion.div
                  key={index}
                  className="logo-large_wrapper"
                  onClick={() => item.link && navigate(item.link)}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: (index % 12) * 0.05 }}
                >
                  <img
                    src={item.img}
                    loading="lazy"
                    alt=""
                    className="logo-large_logo"
                  />
                </motion.div>
              ))}
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default OutStore;
